import { gql, TypedDocumentNode } from '@common/hooks';
import { accountSettingsNotificationsQueryQueryCgResponse } from '@common/graphql';

export const AccountSettingsNotificationsQuery: TypedDocumentNode<accountSettingsNotificationsQueryQueryCgResponse> = gql`
  query accountSettingsNotificationsQuery {
    currentMembership {
      id
      allowEmailNotifications
      notificationCategories {
        key
        name
      }
      notifications {
        category
        enabledForCurrentMembership
        humanizedName
        notificationName
      }
    }
  }
`;
